<div class="signin-v2">
    <div
        class="signin-v2__bg"
        [style.background]="'url(' + backgroundImage + ') center / cover no-repeat'"
        aria-hidden="true"
    ></div>

    <div class="signin-v2__card">
        <div class="signin-v2__overlay" *ngIf="isAutoLogging">
            <div class="signin-v2__overlay-text"></div>
        </div>
        <div class="signin-v2__logo">
            <img [src]="_globals.whiteLabel.logo" alt="{{brandName}} logo" />
        </div>

        <ng-container *ngIf="mode === 'login'">
            <h2 class="signin-v2__title">Welcome to {{brandName}}</h2>
            <p class="signin-v2__subtitle">Please enter your credentials to access your account.</p>
        </ng-container>

        <ng-container *ngIf="mode === 'login' && !isAutoLogging; else forgotView">
            <form [formGroup]="signinForm" (ngSubmit)="signinForm.valid && signin()" novalidate>
                <label class="signin-v2__label" for="email">Email/Username <span class="required">*</span></label>
                <input #emailField id="email" type="text" formControlName="email" pInputText class="signin-v2__input" placeholder="Enter email/username" autocomplete="username" />

                <div class="signin-v2__field">
                    <label class="signin-v2__label" for="password">Password <span class="required">*</span></label>
                    <div class="signin-v2__password">
                        <input #passwordField id="password" [type]="showPassword ? 'text' : 'password'" 
                        formControlName="password" pInputText class="signin-v2__input" placeholder="Enter your password" 
                        autocomplete="new-password" />
                        <button type="button" class="signin-v2__toggle" (click)="togglePassword()" aria-label="Toggle password visibility">
                            <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
                        </button>
                    </div>
                </div>

                <div class="signin-v2__error" *ngIf="_globals.loginErrorMessage?.length">
                    {{ _globals.loginErrorMessage }}
                </div>
                <button type="submit" class="signin-v2__submit" [disabled]="signinForm.invalid">Log in</button>
            </form>

            <div class="signin-v2__links">
                <span class="py-2">Not a Member yet? <a (click)="openPricing()">Sign up</a></span>
                <a class="forgot" (click)="setMode('forgot')">Forgot Password</a>
            </div>
        </ng-container>

        <ng-template #forgotView>
            <form [formGroup]="forgotpasswordForm" (ngSubmit)="forgotpasswordForm.valid && forgotpasswordSubmit()" novalidate>
                <h3 class="signin-v2__title signin-v2__title--small">Forgot Password</h3>
                <p class="signin-v2__subtitle">Enter your email and we will send reset instructions.</p>

                <label class="signin-v2__label" for="reset-email">Username/Email <span class="required">*</span></label>
                <input id="reset-email" type="text" formControlName="email" pInputText class="signin-v2__input" placeholder="Username" />

                <div class="signin-v2__actions">
                    <button type="submit" class="signin-v2__submit" [disabled]="forgotpasswordForm.invalid">Send Reset Password</button>
                </div>
                <div class="signin-v2__backlink">
                    <a (click)="setMode('login')">Back to Login</a>
                </div>
            </form>
        </ng-template>
    </div>
</div>
